import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

import PageTable from "./table";

const PageListing = () => {
    return (
        <Fragment>
            <div className="content-header">
                <h1>Page List</h1>
                <Link to={"/admin/page/add"}>
                    <Button variant="contained">Add</Button>
                </Link>
            </div>
            <PageTable />
        </Fragment>
    );
};

export default PageListing;
